module.exports = __webpack_public_path__ + "img/carLoding.f5be0440.gif";